export default "__VITE_ASSET__SRnit0uA__"